import { useState } from 'react';
import { ComponentProps } from 'lib/component-props';
import useHelpers from '../../../../hooks/helpers';
import useLanguageVersions from '../../../../hooks/useLanguageVersions';
import { useI18n } from 'next-localization';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useChangeLocale } from 'hooks/useChangeLocale';

type LanguageSelectorProps = Partial<ComponentProps> & {
  goBack: () => void;
  className?: string;
};

const LanguageSelectorMobile = ({
  rendering,
  goBack,
  className,
}: LanguageSelectorProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { t } = useI18n();
  const changeLocale = useChangeLocale();
  const languageVersions = useLanguageVersions();

  const [selectedOption, setSelectedOption] = useState({
    hreflang: '',
  });

  const changeLanguage = () => {
    changeLocale(selectedOption.hreflang);
  };

  return (
    <div
      id={anchorId}
      className={`language-selector-mobile ps-2 pe-2 ps-md-6 pe-md-5 ${className}`}
    >
      <div className="mt-md-1 ps-1">
        <p className="form-label">{t('languageSelectorTitle')}</p>
      </div>
      {languageVersions.length !== 0 &&
        languageVersions.map((item, index) => (
          <div
            key={index}
            className="select-item d-flex py-1 mt-1"
            tabIndex={0}
            onClick={() => setSelectedOption(item)}
          >
            <div
              className="outer-circle"
              style={{ borderWidth: selectedOption.hreflang === item.hreflang ? '2px' : '1px' }}
            >
              {selectedOption.hreflang === item.hreflang && <div className="inner-circle" />}
            </div>
            <p className="ms-2 body-default">{item.label}</p>
          </div>
        ))}
      <hr className="mt-5" />
      <div className="my-3">
        <AbrdnButton buttonType="secondary" onClick={goBack}>
          <span>{t('cancel')}</span>
        </AbrdnButton>
        <AbrdnButton className="ms-2" buttonType="primary" onClick={changeLanguage}>
          <span>{t('change')}</span>
        </AbrdnButton>
      </div>
    </div>
  );
};

export default LanguageSelectorMobile;
